import { Input, Form } from 'antd'
import Checkbox from 'antd/lib/checkbox/Checkbox'
import { observer } from 'mobx-react-lite'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ERROR_CODES, ROLE, ROLE_ACCOUNT, STATUS_LOGIN } from '../../helpers/constants'
import { useStore } from '../../hooks'
import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { adminMeta, saleMeta, userMeta } from '../routes/metaData'
import Images from 'src/common/Images'
import { showMessageError } from 'src/helpers/functions'
import { debounce } from 'lodash'
import { AuthenWrapper, LoginWrapper } from 'src/styles/login/Authen.style'
import BaseButton from 'src/common/components/button'
import i18n from 'src/helpers/i18n'
import { createValidationRules } from 'src/helpers/validateRule'
import Title from 'antd/lib/typography/Title'
import { useLoading } from 'src/common/components/LoadingContainer'

const LoginScreen = observer((props: any) => {
   const AuthStore = useStore('AuthStore')

   const { showLoading, hideLoading } = useLoading()
   const { t } = useTranslation()
   const [rememberMe, setRememberMe] = useState(true)
   const { history } = props
   const [form] = Form.useForm()
   // Re-create rules when language changes
   const rule = useMemo(() => createValidationRules(), [i18n.language])

   useEffect(() => {
      if (AuthStore.isLogin === STATUS_LOGIN.LOGIN_SUCCESS) history.push('/')
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [AuthStore.isLogin])

   const onChangeRememberMe = (e: any) => {
      setRememberMe(e.target.checked)
   }

   const onFinishFailed = (errorInfo: any) => {}

   const onFinish = async (values: any) => {
      try {
         console.log('values', values)

         showLoading()
         Object.keys(values)?.forEach((k) => {
            if (typeof values[k] == 'string') return (values[k] = values[k].trim())
         })
         const { phoneNumber, password } = values
         const result = await AuthStore.action_loginUser(phoneNumber, password, rememberMe)
         console.log('12312312', result)

         if (result?.code === ERROR_CODES.SUCCESS) {
            if (result?.data?.account?.role == ROLE_ACCOUNT.ADMIN) history.push(adminMeta[0].items[0].path)
            else if (result?.data?.account?.role == ROLE_ACCOUNT.SALE) history.push(saleMeta[0].items[0].path)
            else history.push(userMeta[0].path)
         } else if (result?.isAccountNotActive) {
            showMessageError(t('account_not_active'), () => history.push('/resend-verify-email'))
         }
      } catch (error) {
         // console.log(error)
      } finally {
         hideLoading()
      }
   }

   return (
      <AuthenWrapper>
         {/* <Loading isLoading={isLoading} /> */}

         <div className="login__banner">
            <div
               style={{
                  backgroundImage: `url(${Images.bg})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center'
               }}
            >
               {/* <img src={Images.ic_logo} alt="" className="img1" /> */}
               <Title className="text_title">Hệ thống quản lý xe ghép Thanh Hóa - Hà Nội</Title>
               <img src={Images.bg_login} alt="" className="img2" />
            </div>
         </div>
         <LoginWrapper className="login__content">
            {/* <StickyChatButton /> */}
            <div className="login-content__body">
               <div className="login-content__logo">
                  <img src={Images.logo_white} alt="" />
               </div>
               <div className="login-content__form">
                  <div className="form__title">{t('login')}</div>
                  <div className="form__desc">{t('register_description')}</div>
                  <Form
                     form={form}
                     name="basic"
                     layout="vertical"
                     onFinish={debounce(onFinish, 600)}
                     onFinishFailed={onFinishFailed}
                     className="gx-signin-form gx-form-row0 login-form__content"
                  >
                     <Form.Item rules={[rule.requiredPhone]} name="phoneNumber" label={'Số điện thoại'}>
                        <Input placeholder={'Nhập số điện thoại'} prefix={<UserOutlined />} maxLength={254} />
                     </Form.Item>
                     <Form.Item rules={[rule.requiredPassword]} name="password" label={t('password')}>
                        <Input.Password
                           type="password"
                           placeholder={t('password')}
                           prefix={<LockOutlined />}
                           maxLength={30}
                        />
                     </Form.Item>
                     <Form.Item>
                        <BaseButton type="primary" className="gx-mb-0" width="100%">
                           {t('login')}
                        </BaseButton>
                     </Form.Item>
                     <Form.Item name="rememberMe" valuePropName="checked">
                        <div className="rememberMe2">
                           <Checkbox
                              checked={rememberMe}
                              onChange={onChangeRememberMe}
                              className="rememberMe"
                              style={{ textAlign: 'start' }}
                           >
                              {t('remember_me')}
                           </Checkbox>
                           {/* <Link className="rememberMe" style={{ textAlign: 'end' }} to="/forgot-password">
                              {t('forgot_password')}?
                           </Link> */}
                        </div>
                     </Form.Item>
                     <div className="form__desc2">{t('no_account_login')}</div>
                  </Form>
               </div>
            </div>
         </LoginWrapper>
      </AuthenWrapper>
   )
})

export default LoginScreen
